import request from '@/utils/request'
import { btcguid } from '@/utils/validate'
import { getToken } from '@/utils/auth'

export function getAdminUser(params) {
  return request({
    url: '/GetAdminUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 101,
      MessageID: btcguid(),
      Data: {
        PageNum: params.pageNum,
        PageSize: params.pageSize,
        // SortOrder: params.sortOrder,
        // SortField: params.sortField,
        KeyWord: params.keyWord
      }
    }
  })
}

export function addAdminUser(params) {
  return request({
    url: '/AddAdminUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 102,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        UserName: params.UserName,
        ChineseName: params.ChineseName,
        EnglishName: params.EnglishName,
        Title: params.Title,
        Responsibility: params.Responsibility,
        Ext: params.Ext,
        Call: params.Call,
        QQ: params.QQ,
        Email: params.Email,
        Order: params.Order
      }
    }
  })
}

export function updateAdminUser(params) {
  return request({
    url: '/UpdateAdminUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 103,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        UserName: params.UserName,
        ChineseName: params.ChineseName,
        EnglishName: params.EnglishName,
        Title: params.Title,
        Responsibility: params.Responsibility,
        Ext: params.Ext,
        Call: params.Call,
        QQ: params.QQ,
        Email: params.Email,
        Order: params.Order
      }
    }
  })
}

export function deleteAdminUser(params) {
  return request({
    url: '/DeleteAdminUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 104,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function getActionList() {
  return request({
    url: '/GetActionList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 105,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function getSystemUser() {
  return request({
    url: '/GetSystemUser',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 106,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function getUserActionList(UserID) {
  return request({
    url: '/GetUserActionList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 107,
      MessageID: btcguid(),
      Data: {
        UserID: UserID
      }
    }
  })
}

export function getAdminUserLoginInfoList(params) {
  return request({
    url: '/GetAdminUserLoginInfoList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 107,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.Keywords
      }
    }
  })
}

export function getAdminUserLoginInfoByID(params) {
  return request({
    url: '/GetAdminUserLoginInfoByID',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 107,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        UserName: params.UserName
      }
    }
  })
}

export function setUserAction(params) {
  return request({
    url: '/SetUserAction',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 108,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        UserActions: params.UserActions
      }
    }
  })
}

export function getUserRegion(userid) {
  return request({
    url: '/GetUserRegion',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 109,
      MessageID: btcguid(),
      Data: {
        UserID: userid
      }
    }
  })
}

export function setUserRegion(params) {
  return request({
    url: '/SetUserRegion',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 110,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        CanVisitCountry: params.CanVisitCountry,
        CanVisitProvince: params.CanVisitProvince
      }
    }
  })
}

export function getFileList(params) {
  return request({
    url: '/GetFileList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 111,
      MessageID: btcguid(),
      Data: {
        PageNum: params.PageNum,
        PageSize: params.PageSize,
        KeyWord: params.KeyWord,
        Type: params.Type
      }
    }
  })
}

export function uploadManageFile(params) {
  const formData = new FormData()
  formData.append('MessageType', 531)
  formData.append('MessageID', btcguid())
  formData.append('Files', params.Files)
  formData.append('Type', params.Type)
  return request({
    url: '/UploadManageFile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: formData
  })
}

export function deleteFile(params) {
  return request({
    url: '/DeleteFile',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 112,
      MessageID: btcguid(),
      Data: {
        FileID: params.FileID,
        FilePath: params.FilePath
      }
    }
  })
}

export function emptyFileManage(params) {
  return request({
    url: '/EmptyFileManage',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 113,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID
      }
    }
  })
}

export function getTabList(params) {
  return request({
    url: '/GetTabList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 114,
      MessageID: btcguid(),
      Data: {}
    }
  })
}

export function addTabList(params) {
  return request({
    url: '/AddTabList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 115,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        Name: params.Name
      }
    }
  })
}

export function deleteTabList(params) {
  return request({
    url: '/DeleteTabList',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 116,
      MessageID: btcguid(),
      Data: {
        Name: params.Name
      }
    }
  })
}

export function updateAdminUserStatus(params) {
  return request({
    url: '/UpdateAdminUserStatus',
    method: 'post',
    headers: {
      'Authorization': getToken()
    },
    data: {
      MessageType: 117,
      MessageID: btcguid(),
      Data: {
        UserID: params.UserID,
        UserName: params.UserName,
        UserStatus: params.UserStatus
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/adminuser.js